import {useApi} from "../Api";
import {AcrissInterface} from "../types/acriss";
import {AcrissOrderResponse, FormSearchAcrissOrderModel} from "../../state/acrissOrder";
import {PagedResponse} from "../types/pagination";
import axios from "axios";
import dayjs from "dayjs";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {SET_SNACKBAR} from "../../constants";
import React from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {buildQueryParams} from "../../utils";

export const useAcrissRepository = () => {
    const {GET, POST, PUT} = useApi();

    const {dispatchGlobalData} = React.useContext(GlobalContext);

    const PATH = "/pricing/acriss-order";

    function getOrderedAcriss(legalEntity?: string): Promise<AcrissInterface[]> {
        return GET(`${PATH}/acriss-list?legalEntities=${legalEntity}`);
    }

    function getOrderedAcrissCarGroupType(carGroupType: string, legalEntity: string): Promise<AcrissInterface[]> {
        return GET(`${PATH}/acriss-list?carGroupType=${carGroupType}&legalEntities=${legalEntity}`);
    }

    function orderCarGroupsByAcrissOrder(carGroupType: string[], legalEntity: string): Promise<string[]> {
        return POST(`${PATH}/sort?legalEntity=${legalEntity}`, carGroupType);
    }

    function getAllAcriss(filters: FormSearchAcrissOrderModel): Promise<PagedResponse<AcrissOrderResponse[]>> {

        const query = "?";
        const queryParams = buildQueryParams(filters);
        return GET(`${PATH}/get-all${queryParams ? query + queryParams : ""}`);
    }

    function exportAcrissOrder(legalEntity: string): Promise<void> {
        return axios.get(`${PATH}/export?legalEntity=${legalEntity}`, {
            headers: {
                'Content-type': 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet'
            },
            responseType: 'blob',
        })
            .then(({data}) => {
                const blob = new Blob([data], {
                    type: `application/${'vnd.openxmlformatsofficedocument.spreadsheetml.sheet'}`,
                });

                const url = window.URL.createObjectURL(blob); // creiamo l'url al Blob
                const a = document.createElement('a'); // creiamo un elemento nel DOM
                const title = `export_acriss_order_${dayjs().format("YYYYMMDDHHmm")}_${legalEntity}.xlsx`; // creiamo il titolo per il file

                a.href = url; // appendiamo l'url del Blob all'elemento creato
                a.download = `${title}`; // appendiamo la proprietà di download con nome ed estension del file
                a.click(); // aggiungiamo il click event per procedere al download

            })

            .catch(async error => {

                let parsedError = JSON.parse(await error.response.data.text())
                let parsed = JSON.parse(await parsedError.errorDetails)
                if (await parsed) {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: parsed.reportedErrors,
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                } else {
                    dispatchGlobalData(SET_SNACKBAR.ERROR);
                }
                return Promise.reject(error);
            })
    }

    function exportLastAcrissOrder(legalEntity: string): Promise<void> {
        return axios.get(`${PATH}/export-last-order?legalEntity=${legalEntity}`, {
            headers: {
                'Content-type': 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet'
            },
            responseType: 'blob',
        })
            .then(({data}) => {
                const blob = new Blob([data], {
                    type: `application/${'vnd.openxmlformatsofficedocument.spreadsheetml.sheet'}`,
                });

                const url = window.URL.createObjectURL(blob); // creiamo l'url al Blob
                const a = document.createElement('a'); // creiamo un elemento nel DOM
                const title = `export_last_acriss_order_${dayjs().format("YYYYMMDDHHmm")}_${legalEntity}.xlsx`; // creiamo il titolo per il file

                a.href = url; // appendiamo l'url del Blob all'elemento creato
                a.download = `${title}`; // appendiamo la proprietà di download con nome ed estension del file
                a.click(); // aggiungiamo il click event per procedere al download

            })

            .catch(async error => {

                let parsedError = JSON.parse(await error.response.data.text())
                let parsed = JSON.parse(await parsedError.errorDetails)
                if (await parsed) {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: parsed.reportedErrors,
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                } else {
                    dispatchGlobalData(SET_SNACKBAR.ERROR);
                }
                return Promise.reject(error);
            })
    }

    function importFileAcrissOrder(legalEntity: string, excelFile: File): Promise<boolean> {
        let formData = new FormData();
        formData.append("xlsFile", excelFile);

        return PUT(`${PATH}/import?legalEntity=${legalEntity}`, formData, {headers: {"Content-Type": "multipart/form-data"}}, true);
    }

    return {
        getOrderedAcriss,
        getOrderedAcrissCarGroupType,
        orderCarGroupsByAcrissOrder,
        getAllAcriss,
        exportAcrissOrder,
        exportLastAcrissOrder,
        importFileAcrissOrder
    };
};